module.exports = __webpack_public_path__ + "static/media/PATS_5-768w.6ae73649.png";